import { render, staticRenderFns } from "./ChooseAirplane.vue?vue&type=template&id=004c7dc1&"
import script from "./ChooseAirplane.vue?vue&type=script&lang=js&"
export * from "./ChooseAirplane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/opt/buildhome/repo/components/global/Spinner.vue').default,AirplaneItem: require('/opt/buildhome/repo/components/global/AirplaneItem.vue').default,Button: require('/opt/buildhome/repo/components/global/Button.vue').default})
